<template>
  <div
    class="absolute transition-all duration-300"
    :style="{ top: position.top, left: position.left }"
  >
    <div
      id="recurring-slot"
      class="border-l-4 rounded-xl bg-pure-white transition-all duration-300"
      :style="{
        height: assets.height,
        width: assets.width,
        borderColor: isOpenRoom ? borderOpenRoom : borderColor
      }"
    >
      <div
        class="h-full w-full py-1 px-1 flex flex-col justify-between gap-1 border-2 border-l-0 border-dashed rounded-lg"
        :style="{ borderColor }"
      >
        <div
          class="relative h-full w-full py-1 px-1.5 rounded"
          :style="{ backgroundColor }"
        >
          <div
            v-if="error"
            class="h-full flex gap-1"
            :class="{
              'items-center': isCompact && periodCount === 1,
              'flex-col justify-center': !isCompact || periodCount > 1
            }"
          >
            <BlIcon icon="warning" color="error" class="h-6 w-6" />
            <BlTextSubtitle3
              text="Conflicting timeslot"
              :style="{ color: textColor }"
              class="truncate"
            />
            <BlTextBody2
              v-if="!isCompact || periodCount > 1"
              text="Please review"
              :style="{ color: textColor }"
            />
          </div>
          <div
            v-else
            class="h-full flex gap-1 truncate"
            :class="{
              'items-center justify-between': isCompact && periodCount === 1,
              'flex-col justify-center': !isCompact || periodCount > 1,
              'pt-2': isOpenRoom
            }"
          >
            <BlTextSubtitle3
              v-if="client.name && (!isCompact || periodCount > 1)"
              :text="`${client.name}`"
              :style="{ color: textColor }"
              class="truncate"
            />
            <BlTextSubtitle3
              v-if="therapist.name"
              :text="`${therapist.name}`"
              :style="{ color: textColor }"
              class="truncate"
            />
            <BlTextBody2
              v-if="
                !isCompact ||
                  (isOpenRoom && periodCount > 2) ||
                  (!isOpenRoom && periodCount > 1)
              "
              :text="`${period.start_time_string} - ${period.end_time_string}`"
              :style="{ color: textColor }"
            />
            <BlTextBody2
              v-if="
                !isCompact &&
                  periodCount > 1 &&
                  enableBranch &&
                  room &&
                  room.branch
              "
              :text="`${room.branch.name}`"
              :style="{ color: textColor }"
              class="truncate"
            />
            <BlTextBody2
              v-if="room.name"
              :text="`${room.name}`"
              :style="{ color: textColor }"
              class="truncate min-w-16"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isOpenRoom"
        class="border border-l-4 rounded-t-lg px-4 w-full absolute top-0 left-0 flex items-center justify-center"
        :style="{
          height: isCompact ? '1.25rem' : '1.625rem',
          borderColor: borderOpenRoom,
          backgroundColor: backgroundOpenRoom
        }"
      >
        <div class="flex justify-center truncate">
          <BlTextBody2
            text="Open room"
            class="truncate"
            :style="{ color: textColorOpenRoom }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlTextBody3 from "../../BlTextBody3.vue";
import BlIcon from "../../BlIcon.vue";

export default {
  name: "SlotRecurring",
  components: {
    BlTextSubtitle3,
    BlTextBody2,
    BlTextBody3,
    BlIcon
  },
  props: {
    isCompact: { type: Boolean, default: false },
    isOpenRoom: { type: Boolean, default: false },
    period: {
      type: Object,
      default: () => ({ start_time_string: "00:00", end_time_string: "01:00" })
    },
    client: {
      type: Object,
      default: () => ({ id: 0, name: "" })
    },
    therapist: {
      type: Object,
      default: () => ({ id: 0, name: "" })
    },
    room: {
      type: Object,
      default: () => ({ id: 0, name: "", branch: null })
    },
    position: { type: Object, default: () => ({ top: 0, left: 0 }) },
    assets: {
      type: Object,
      default: () => ({
        height: `calc(2 * ${this.isCompact ? 3.125 : 7.5}rem - 2px)`,
        width: "calc(((100vw - 6rem - 0.5rem) / 7) - 2px)",
        background_color: "#F2F4F7",
        border_color: "#F2F4F7",
        color: "#667085"
      })
    },
    error: { type: Boolean, default: false }
  },
  data() {
    return {
      backgroundOpenRoom: "#C5CAE9",
      borderOpenRoom: "#303F9F",
      textColorOpenRoom: "#303F9F",
      //
      backgroundColor: "",
      borderColor: "",
      textColor: ""
    };
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter"]),
    periodCount() {
      return this.getSlotCount(
        this.period.start_time_string,
        this.period.end_time_string
      );
    },
    enableBranch() {
      return this.currentCenter.enable_branch;
    }
  },
  watch: {},
  mounted() {
    this.backgroundColor = this.assets.background_color;
    this.borderColor = this.assets.border_color;
    this.textColor = this.assets.color;
    if (this.error) {
      this.backgroundColor = "#FEF3F2";
      this.borderColor = "#DD3F30";
      this.textColor = "#DD3F30";
    }
  },
  methods: {
    displayDate(date) {
      return moment(date).format("dddd, DD MMM YYYY");
    },
    getSlotCount(start, end) {
      const s = start.split(":").map(i => Number(i));
      const e = end.split(":").map(i => Number(i));
      let slots = 0;
      slots += (e[0] - s[0]) * 2;
      if (s[1] === 30) slots -= 1;
      if (e[1] === 30) slots += 1;
      return slots;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/appointments/overlay/SlotRecurring.vue